import React, { Component } from 'react';
import ReactDOM from 'react-dom';

const MImageType = {
  ScaleToFill: 'ScaleToFill', // 缩放
  ScaleAspectFit: 'ScaleAspectFit', // 压缩留白
  ScaleAspectFill: 'ScaleAspectFill' // 压缩不留白
};

/* eslint-disable react/no-unsafe */
class MImage extends Component<any, any> {
  img: any;

  constructor(props: any) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
  }

  static defaultProps = {
    width: undefined,
    height: undefined,
    draggable: true,
    contentMode: MImageType.ScaleAspectFill,
    onError: (err: any) => {
      console.error(err);
    },
    onLoad: () => {}
  };

  componentWillUnmount() {
    this.img.onload = null;
    this.img.onerror = null;
  }

  componentDidMount() {
    const img = (this.img = new window.Image()); // eslint-disable-line no-multi-assign
    // // 报错
    // let num = 0;
    // let timer = null;
    // img.onerror = (err) => {
    //   timer = setTimeout(() => {
    //     if (num >= 360) {
    //       clearTimeout(timer);
    //       num = 0;
    //       this.setState({
    //         loading: false
    //       }, () => {
    //         this.props.onError();
    //       });
    //     } else {
    //       num++;
    //       img.src = src;
    //     }
    //   }, 2000);
    // }

    // 如果报错 并且有errorUrl 则替换图片
    img.onerror = () => {
      if (this.props.errorImg && img.src !== this.props.errorImg) {
        img.src = this.props.errorImg;
      }
    };

    img.onload = () => {
      // 图片的宽高和比例
      const iw = img.width;
      const ih = img.height;
      const { width, height, left, top } = this.calculateSize({ iw, ih });
      this.setState({
        width,
        height,
        left,
        top
      });
      // @ts-ignore
      if (this.refs.image) this.refs.image.src = img.src; // eslint-disable-line react/no-string-refs
      this.props.onLoad();
    };

    const src = this.props.url || (this.props.data && this.props.data[this.props.type]);
    if (src) {
      img.src = src;
      this.setState({});
    }
    // 若没有src且有errorImg 则显示errorImg todo 优化
    if (!src && this.props.errorImg) {
      img.src = this.props.errorImg;
      this.setState({});
    }
  }

  calculateSize = ({ iw, ih }: any) => {
    const containerDom: any = ReactDOM.findDOMNode(this.refs.container); // eslint-disable-line react/no-string-refs,react/no-find-dom-node
    // 容器宽高
    const cw = this.props.width || containerDom.clientWidth;
    const ch = this.props.height || containerDom.clientHeight;

    let width: any = 0;
    let height: any = 0;
    let left: any = 0;
    let top: any = 0;

    const wv = iw / cw;
    const hv = ih / ch;

    // 图片展示类型
    switch (this.props.contentMode) {
      // 压缩不留白
      case MImageType.ScaleAspectFill:
        if (wv >= hv) {
          top = 0;
          // height = ch;
          // left = (iw / hv - cw) * -0.5;
          // width = iw / hv;
          height = '100%';
          width = `${(iw / hv / cw) * 100}%`;
          left = `${50 + (iw / hv / cw) * 100 * -0.5}%`;
        } else {
          left = 0;
          // width = cw;
          // top = (ih / wv - ch) * -0.5;
          // height = ih / wv;
          width = '100%';
          height = `${(ih / wv / ch) * 100}%`;
          top = `${50 + (ih / wv / ch) * 100 * -0.5}%`;
        }
        break;
      // 压缩留白
      case MImageType.ScaleAspectFit:
        if (wv > hv) {
          left = 0;
          // width = cw;
          // top = (ih / wv - ch) * -0.5;
          // height = ih / wv;
          width = '100%';
          height = `${(ih / wv / ch) * 100}%`;
          top = `${50 + (ih / wv / ch) * 100 * -0.5}%`;
        } else {
          top = 0;
          // height = ch;
          // left = (iw / hv - pw) * -0.5;
          // width = iw / hv;
          height = '100%';
          width = `${(iw / hv / cw) * 100}%`;
          left = `${50 + (iw / hv / cw) * 100 * -0.5}%`;
        }
        break;
      // 缩放
      case MImageType.ScaleToFill:
        width = '100%';
        height = '100%';
        top = 0;
        left = 0;
        break;
      default:
        break;
    }

    return {
      width,
      height,
      left,
      top
    };
  };

  UNSAFE_componentWillReceiveProps(props: any) {
    if (this.props.url !== props.url) {
      this.img.src = props.url;
    }
  }

  render() {
    // let resize = this.props.resize;
    const { width, height, left, top } = this.state;

    const { needTransparent = false, addonElement = null, className = '' } = this.props;

    // if (resize && iw) {
    //   let _size = this.calculateSize({iw, ih});
    //   width = _size.width;
    //   height = _size.height;
    //   left = _size.left;
    //   top = _size.top;
    // }

    const imgStyle: any = {
      display: 'block',
      position: 'absolute',
      width,
      height,
      top,
      left
    };
    // 是否需要显示透明背景
    if (needTransparent) {
      imgStyle.backgroundImage =
        'linear-gradient(45deg, #EEE 25%, transparent 25%, transparent 75%, #EEE 75%, #EEE), ' +
        'linear-gradient(45deg, #EEE 26%, #fff 26%, #fff 74%, #EEE 74%, #EEE)';
      imgStyle.backgroundSize = '20px 20px';
      imgStyle.backgroundPosition = '0 0, 10px 10px';
    }

    return (
      <div
        ref="container" // eslint-disable-line react/no-string-refs
        style={{
          position: 'relative',
          overflow: 'hidden',
          width: '100%',
          height: '100%',
          userSelect: 'none'
        }}
        className={className}
      >
        <img
          ref="image" // eslint-disable-line react/no-string-refs
          style={imgStyle}
          draggable={this.props.draggable}
          alt=""
        />
        {addonElement &&
          addonElement({
            width,
            height,
            top,
            left
          })}
      </div>
    );
  }
}

export default MImage;
